// core/services/exploreService.ts — B4c: API-backed Explore data.
//
// Thin fetch wrappers over the public /api/explore/* endpoints (derived from real
// posts; collections are an empty list until any exist for real — the panel
// says "No collections yet."). Store-less. feed() keeps its client-side
// topic/sort filter so the method signature behaves as before (the page calls
// ('all','recent') and does the rest via filterExplore).

import type { ExploreTopic, ExploreItem, FeaturedCollection } from '@/core/models/explore';
import { api } from '@/core/lib/apiClient';

export type ExploreSort = 'trending' | 'popular' | 'recent';

export const exploreService = {
  async topics(): Promise<ExploreTopic[]> {
    return api<ExploreTopic[]>('/explore/topics/');
  },

  async feed(topicId: string = 'all', sort: ExploreSort = 'recent'): Promise<ExploreItem[]> {
    let items = await api<ExploreItem[]>('/explore/feed/');
    if (topicId !== 'all') items = items.filter((i) => i.topic === topicId);
    if (sort === 'trending') {
      items = items.filter((i) => i.trending);
    } else if (sort === 'popular') {
      items = items.filter((i) => i.popular);
    } else {
      items = [...items].sort((a, b) => b.ts - a.ts);
    }
    return items;
  },

  async featuredCollections(): Promise<FeaturedCollection[]> {
    return api<FeaturedCollection[]>('/explore/collections/');
  },
} as const;
